import { Box, Chip, Divider, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Done } from "lib/@components/done"
import { If } from "lib/@components/switch"
import { MacroExpander } from "authoring/routes/macro/components/macro-expander"
import { hasAudienceAmendsContent, normalizeAudienceAmends } from "../lib/audience-aware-amends.mjs"
import { hasAmendsContent } from "../lib/amends-content"
import { sanitizeAmendsHtml } from "../lib/sanitize-amends-html"

// Content is sanitized via sanitizeAmendsHtml — trusted authored HTML from the platform
export function AuthoringAmendsContentDialog({ content, noteData, title = "Author Note", plainText = false }) {
    const normalizedNote = normalizeAudienceAmends(noteData ?? { content })
    const textContent = `${content ?? ""}`
    const hasAnyContent = hasAudienceAmendsContent(normalizedNote)

    return (
        <DialogBox title={title} Actions={Done}>
            <MacroExpander>
                <If truthy={plainText}>
                    <Typography variant="body2" sx={{ mt: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {textContent}
                    </Typography>
                </If>
                <If truthy={!plainText && normalizedNote.isSplit}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1.5, mb: 1 }}>
                        <Typography variant="subtitle2">Split note</Typography>
                        <Chip label="Split" size="small" color="info" variant="outlined" />
                    </Stack>
                    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                        Internal
                    </Typography>
                    {renderContent(normalizedNote.internalContent)}
                    <Divider sx={{ my: 1.5 }} />
                    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                        External
                    </Typography>
                    {renderContent(normalizedNote.externalContent)}
                </If>
                <If truthy={!plainText && !normalizedNote.isSplit && hasAnyContent}>
                    {renderContent(normalizedNote.content)}
                </If>
            </MacroExpander>
        </DialogBox>
    )
}

function renderContent(content) {
    const sanitizedContent = sanitizeAmendsHtml(content)

    if (!hasAmendsContent(content)) {
        return (
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                No content
            </Typography>
        )
    }

    return (
        <Box
            sx={{ "& p": { m: 0 }, "& p + p": { mt: 1 }, wordBreak: "break-word" }}
            dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
    )
}
